export enum TabType {
  TOGETHER = 'TOGETHER',
  SEPARATE = 'SEPARATE',
}

export enum TabSize {
  NORMAL = 'NORMAL',
  LARGE = 'LARGE',
}
